export default __webpack_public_path__ + "static/0088-d63553c6028946299eb01b1ad3d63562.png";